var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('comment-tile',{staticClass:"commment-tile",attrs:{"commentsData":_vm.commentsData}}),_c('comment-swiper',{staticClass:"comment-swiper",attrs:{"commentsData":_vm.commentsData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }